// 企業別の色を生成・管理
const COMPANY_COLORS = [
  { primary: '#f5a86e', light: '#fcd3b9', dark: '#e8874a' }, // 企業1: オレンジ
  { primary: '#6bb3e0', light: '#b0d6f0', dark: '#4a9cd4' }, // 企業2: 青
  { primary: '#9f7ab5', light: '#ccb9de', dark: '#7d5a91' }, // 企業3: 紫
  { primary: '#7bc67e', light: '#c4e8c5', dark: '#5ba55e' }, // 企業4: 緑
  { primary: '#f57c00', light: '#ffe0b2', dark: '#e65100' }, // 企業5: オレンジ
  { primary: '#0097a7', light: '#b2ebf2', dark: '#006064' }, // 企業6: シアン
  { primary: '#c2185b', light: '#f8bbd0', dark: '#880e4f' }, // 企業7: ピンク
  { primary: '#5d4037', light: '#d7ccc8', dark: '#3e2723' }, // 企業8: ブラウン
];

const companyColorMap = new Map();

// M365モード用のデフォルト色（トポロジ社: 青系）
const DEFAULT_COLOR = { primary: '#6bb3e0', light: '#b0d6f0', dark: '#4a9cd4' };

// ドメイン別の色設定（M365モード用）
const DOMAIN_COLORS = {
  'liberalsya.com': { primary: '#f57c00', light: '#ffe0b2', dark: '#e65100' }, // リベラル社: オレンジ
  'tplg.co.jp': { primary: '#6bb3e0', light: '#b0d6f0', dark: '#4a9cd4' },     // トポロジ社: 青
};

/**
 * メールアドレスからドメインを抽出
 * @param {string} email - メールアドレス
 * @returns {string|null} ドメイン
 */
const extractDomain = (email) => {
  if (!email || typeof email !== 'string') return null;
  const parts = email.split('@');
  return parts.length === 2 ? parts[1].toLowerCase() : null;
};

/**
 * ドメインに基づいて色を取得（M365モード用）
 * @param {string} email - メールアドレス
 * @returns {Object} 色オブジェクト { primary, light, dark }
 */
export const getColorByEmail = (email) => {
  const domain = extractDomain(email);
  if (domain && DOMAIN_COLORS[domain]) {
    return DOMAIN_COLORS[domain];
  }
  return DEFAULT_COLOR;
};

/**
 * 企業IDに基づいて色を取得
 * @param {number} companyId - 企業ID
 * @returns {Object} 色オブジェクト { primary, light, dark }
 */
export const getCompanyColor = (companyId) => {
  // companyIdがnull/undefinedの場合はデフォルト色を返す（M365モード対応）
  if (companyId == null) {
    return DEFAULT_COLOR;
  }
  if (!companyColorMap.has(companyId)) {
    const colorIndex = (companyId - 1) % COMPANY_COLORS.length;
    companyColorMap.set(companyId, COMPANY_COLORS[colorIndex]);
  }
  return companyColorMap.get(companyId);
};

/**
 * 予約ブロックのスタイルを生成
 * @param {number} companyId - 企業ID
 * @param {boolean} isOwnCompany - 自社の予約かどうか
 * @param {boolean} isEditable - 編集可能かどうか
 * @param {string} roomType - 会議室タイプ (A, B, AB)
 * @param {string} organizerEmail - 主催者のメールアドレス（M365モード用）
 * @returns {Object} スタイルオブジェクト
 */
export const getReservationStyle = (companyId, isOwnCompany, isEditable = false, roomType = 'A', organizerEmail = null) => {
  // M365モードの場合（companyIdがnullでorganizerEmailがある場合）はドメイン別の色を使用
  const colors = organizerEmail ? getColorByEmail(organizerEmail) : getCompanyColor(companyId);

  return {
    backgroundColor: colors.light,
    borderLeft: `4px solid ${colors.primary}`,
    color: '#333',
    cursor: isEditable ? 'move' : 'default',
  };
};

/**
 * 会議室の背景色を取得
 * @param {string} roomType - 会議室タイプ (A, B, AB)
 * @returns {string} 背景色
 */
export const getRoomBackgroundColor = (roomType) => {
  const colors = {
    G: '#f5f5f5',
    B: '#fafafa',
    GB: '#f9f9f9',
  };
  return colors[roomType] || '#ffffff';
};

/**
 * ドラッグ中の予約のスタイル
 */
export const getDraggingStyle = () => ({
  opacity: 0.5,
  cursor: 'grabbing',
});

/**
 * ドロップ可能エリアのスタイル
 * @param {boolean} canDrop - ドロップ可能かどうか
 * @param {boolean} isOver - マウスがホバー中かどうか
 */
export const getDropTargetStyle = (canDrop, isOver) => {
  if (!canDrop) {
    return {
      backgroundColor: '#ffebee', // 薄い赤（ドロップ不可）
    };
  }

  if (isOver) {
    return {
      backgroundColor: '#e8f5e9', // 薄い緑（ドロップ可能でホバー中）
      outline: '2px dashed #4caf50',
    };
  }

  return {};
};
